import { Injectable } from "@angular/core";
import { ISideNavigationData } from "./side-navigation-data";

@Injectable({
  providedIn: 'root'
})
export class SideNavigationService {
  public navigationData: ISideNavigationData[];
}